import {UserType} from '../models/user';
import {SelectOption} from '../models/select-option';

export class ConstantsUtils {
    public static carBoostTypes: SelectOption<String>[] = [
        {label: 'A+', value: 'aplus'},
        {label: 'A', value: 'a'},
        {label: 'B', value: 'b'},
        {label: 'Fara Clasa', value: 'nothing'},
    ];

    public static userTypes: SelectOption<UserType>[] = [
        {label: 'Admin', value: UserType.admin},
        {label: 'Rider', value: UserType.rider},
        {label: 'Driver', value: UserType.driver},
    ];

    public static countries = [
        { code: 'AF', flag: '🇦🇫', phoneCode: 93, value: 'Afghanistan' },
        { code: 'AL', flag: '🇦🇱', phoneCode: 355, value: 'Albania' },
        { code: 'DZ', flag: '🇩🇿', phoneCode: 213, value: 'Algeria' },
        { code: 'AS', flag: '🇦🇸', phoneCode: 1684, value: 'American Samoa' },
        { code: 'AD', flag: '🇦🇩', phoneCode: 376, value: 'Andorra' },
        { code: 'AO', flag: '🇦🇴', phoneCode: 244, value: 'Angola' },
        { code: 'AI', flag: '🇦🇮', phoneCode: 1264, value: 'Anguilla' },
        { code: 'AQ', flag: '🇦🇶', phoneCode: 0, value: 'Antarctica' },
        { code: 'AR', flag: '🇦🇷', phoneCode: 54, value: 'Argentina' },
        { code: 'AM', flag: '🇦🇲', phoneCode: 374, value: 'Armenia' },
        { code: 'AW', flag: '🇦🇼', phoneCode: 297, value: 'Aruba' },
        { code: 'AU', flag: '🇦🇺', phoneCode: 61, value: 'Australia' },
        { code: 'AT', flag: '🇦🇹', phoneCode: 43, value: 'Austria' },
        { code: 'AZ', flag: '🇦🇿', phoneCode: 994, value: 'Azerbaijan' },
        { code: 'BH', flag: '🇧🇭', phoneCode: 973, value: 'Bahrain' },
        { code: 'BD', flag: '🇧🇩', phoneCode: 880, value: 'Bangladesh' },
        { code: 'BB', flag: '🇧🇧', phoneCode: 1246, value: 'Barbados' },
        { code: 'BY', flag: '🇧🇾', phoneCode: 375, value: 'Belarus' },
        { code: 'BE', flag: '🇧🇪', phoneCode: 32, value: 'Belgium' },
        { code: 'BZ', flag: '🇧🇿', phoneCode: 501, value: 'Belize' },
        { code: 'BJ', flag: '🇧🇯', phoneCode: 229, value: 'Benin' },
        { code: 'BM', flag: '🇧🇲', phoneCode: 1441, value: 'Bermuda' },
        { code: 'BT', flag: '🇧🇹', phoneCode: 975, value: 'Bhutan' },
        { code: 'BO', flag: '🇧🇴', phoneCode: 591, value: 'Bolivia' },
        { code: 'BW', flag: '🇧🇼', phoneCode: 267, value: 'Botswana' },
        { code: 'BV', flag: '🇧🇻', phoneCode: 0, value: 'Bouvet Island' },
        { code: 'BR', flag: '🇧🇷', phoneCode: 55, value: 'Brazil' },
        { code: 'IO', flag: '🇮🇴', phoneCode: 246, value: 'British Indian Ocean Territory' },
        { code: 'BN', flag: '🇧🇳', phoneCode: 673, value: 'Brunei' },
        { code: 'BG', flag: '🇧🇬', phoneCode: 359, value: 'Bulgaria' },
        { code: 'BF', flag: '🇧🇫', phoneCode: 226, value: 'Burkina Faso' },
        { code: 'BI', flag: '🇧🇮', phoneCode: 257, value: 'Burundi' },
        { code: 'KH', flag: '🇰🇭', phoneCode: 855, value: 'Cambodia' },
        { code: 'CM', flag: '🇨🇲', phoneCode: 237, value: 'Cameroon' },
        { code: 'CA', flag: '🇨🇦', phoneCode: 1, value: 'Canada' },
        { code: 'CV', flag: '🇨🇻', phoneCode: 238, value: 'Cape Verde' },
        { code: 'KY', flag: '🇰🇾', phoneCode: 1345, value: 'Cayman Islands' },
        { code: 'CF', flag: '🇨🇫', phoneCode: 236, value: 'Central African Republic' },
        { code: 'TD', flag: '🇹🇩', phoneCode: 235, value: 'Chad' },
        { code: 'CL', flag: '🇨🇱', phoneCode: 56, value: 'Chile' },
        { code: 'CN', flag: '🇨🇳', phoneCode: 86, value: 'China' },
        { code: 'CX', flag: '🇨🇽', phoneCode: 61, value: 'Christmas Island' },
        { code: 'CC', flag: '🇨🇨', phoneCode: 672, value: 'Cocos (Keeling) Islands' },
        { code: 'CO', flag: '🇨🇴', phoneCode: 57, value: 'Colombia' },
        { code: 'KM', flag: '🇰🇲', phoneCode: 269, value: 'Comoros' },
        { code: 'CK', flag: '🇨🇰', phoneCode: 682, value: 'Cook Islands' },
        { code: 'CR', flag: '🇨🇷', phoneCode: 506, value: 'Costa Rica' },
        { code: 'CU', flag: '🇨🇺', phoneCode: 53, value: 'Cuba' },
        { code: 'CY', flag: '🇨🇾', phoneCode: 357, value: 'Cyprus' },
        { code: 'DK', flag: '🇩🇰', phoneCode: 45, value: 'Denmark' },
        { code: 'DJ', flag: '🇩🇯', phoneCode: 253, value: 'Djibouti' },
        { code: 'DM', flag: '🇩🇲', phoneCode: 1767, value: 'Dominica' },
        { code: 'DO', flag: '🇩🇴', phoneCode: 1809, value: 'Dominican Republic' },
        { code: 'EC', flag: '🇪🇨', phoneCode: 593, value: 'Ecuador' },
        { code: 'EG', flag: '🇪🇬', phoneCode: 20, value: 'Egypt' },
        { code: 'SV', flag: '🇸🇻', phoneCode: 503, value: 'El Salvador' },
        { code: 'GQ', flag: '🇬🇶', phoneCode: 240, value: 'Equatorial Guinea' },
        { code: 'ER', flag: '🇪🇷', phoneCode: 291, value: 'Eritrea' },
        { code: 'EE', flag: '🇪🇪', phoneCode: 372, value: 'Estonia' },
        { code: 'ET', flag: '🇪🇹', phoneCode: 251, value: 'Ethiopia' },
        { code: 'FK', flag: '🇫🇰', phoneCode: 500, value: 'Falkland Islands' },
        { code: 'FO', flag: '🇫🇴', phoneCode: 298, value: 'Faroe Islands' },
        { code: 'FI', flag: '🇫🇮', phoneCode: 358, value: 'Finland' },
        { code: 'FR', flag: '🇫🇷', phoneCode: 33, value: 'France' },
        { code: 'GF', flag: '🇬🇫', phoneCode: 594, value: 'French Guiana' },
        { code: 'PF', flag: '🇵🇫', phoneCode: 689, value: 'French Polynesia' },
        { code: 'TF', flag: '🇹🇫', phoneCode: 0, value: 'French Southern Territories' },
        { code: 'GA', flag: '🇬🇦', phoneCode: 241, value: 'Gabon' },
        { code: 'GE', flag: '🇬🇪', phoneCode: 995, value: 'Georgia' },
        { code: 'DE', flag: '🇩🇪', phoneCode: 49, value: 'Germany' },
        { code: 'GH', flag: '🇬🇭', phoneCode: 233, value: 'Ghana' },
        { code: 'GI', flag: '🇬🇮', phoneCode: 350, value: 'Gibraltar' },
        { code: 'GR', flag: '🇬🇷', phoneCode: 30, value: 'Greece' },
        { code: 'GL', flag: '🇬🇱', phoneCode: 299, value: 'Greenland' },
        { code: 'GD', flag: '🇬🇩', phoneCode: 1473, value: 'Grenada' },
        { code: 'GP', flag: '🇬🇵', phoneCode: 590, value: 'Guadeloupe' },
        { code: 'GU', flag: '🇬🇺', phoneCode: 1671, value: 'Guam' },
        { code: 'GT', flag: '🇬🇹', phoneCode: 502, value: 'Guatemala' },
        { code: 'GN', flag: '🇬🇳', phoneCode: 224, value: 'Guinea' },
        { code: 'GW', flag: '🇬🇼', phoneCode: 245, value: 'Guinea-Bissau' },
        { code: 'GY', flag: '🇬🇾', phoneCode: 592, value: 'Guyana' },
        { code: 'HT', flag: '🇭🇹', phoneCode: 509, value: 'Haiti' },
        { code: 'HN', flag: '🇭🇳', phoneCode: 504, value: 'Honduras' },
        { code: 'HU', flag: '🇭🇺', phoneCode: 36, value: 'Hungary' },
        { code: 'IS', flag: '🇮🇸', phoneCode: 354, value: 'Iceland' },
        { code: 'IN', flag: '🇮🇳', phoneCode: 91, value: 'India' },
        { code: 'ID', flag: '🇮🇩', phoneCode: 62, value: 'Indonesia' },
        { code: 'IR', flag: '🇮🇷', phoneCode: 98, value: 'Iran' },
        { code: 'IQ', flag: '🇮🇶', phoneCode: 964, value: 'Iraq' },
        { code: 'IE', flag: '🇮🇪', phoneCode: 353, value: 'Ireland' },
        { code: 'IL', flag: '🇮🇱', phoneCode: 972, value: 'Israel' },
        { code: 'IT', flag: '🇮🇹', phoneCode: 39, value: 'Italy' },
        { code: 'JM', flag: '🇯🇲', phoneCode: 1876, value: 'Jamaica' },
        { code: 'JP', flag: '🇯🇵', phoneCode: 81, value: 'Japan' },
        { code: 'JO', flag: '🇯🇴', phoneCode: 962, value: 'Jordan' },
        { code: 'KZ', flag: '🇰🇿', phoneCode: 7, value: 'Kazakhstan' },
        { code: 'KE', flag: '🇰🇪', phoneCode: 254, value: 'Kenya' },
        { code: 'KI', flag: '🇰🇮', phoneCode: 686, value: 'Kiribati' },
        { code: 'KW', flag: '🇰🇼', phoneCode: 965, value: 'Kuwait' },
        { code: 'KG', flag: '🇰🇬', phoneCode: 996, value: 'Kyrgyzstan' },
        { code: 'LA', flag: '🇱🇦', phoneCode: 856, value: 'Laos' },
        { code: 'LV', flag: '🇱🇻', phoneCode: 371, value: 'Latvia' },
        { code: 'LB', flag: '🇱🇧', phoneCode: 961, value: 'Lebanon' },
        { code: 'LS', flag: '🇱🇸', phoneCode: 266, value: 'Lesotho' },
        { code: 'LR', flag: '🇱🇷', phoneCode: 231, value: 'Liberia' },
        { code: 'LY', flag: '🇱🇾', phoneCode: 218, value: 'Libya' },
        { code: 'LI', flag: '🇱🇮', phoneCode: 423, value: 'Liechtenstein' },
        { code: 'LT', flag: '🇱🇹', phoneCode: 370, value: 'Lithuania' },
        { code: 'LU', flag: '🇱🇺', phoneCode: 352, value: 'Luxembourg' },
        { code: 'MK', flag: '🇲🇰', phoneCode: 389, value: 'Macedonia' },
        { code: 'MG', flag: '🇲🇬', phoneCode: 261, value: 'Madagascar' },
        { code: 'MW', flag: '🇲🇼', phoneCode: 265, value: 'Malawi' },
        { code: 'MY', flag: '🇲🇾', phoneCode: 60, value: 'Malaysia' },
        { code: 'MV', flag: '🇲🇻', phoneCode: 960, value: 'Maldives' },
        { code: 'ML', flag: '🇲🇱', phoneCode: 223, value: 'Mali' },
        { code: 'MT', flag: '🇲🇹', phoneCode: 356, value: 'Malta' },
        { code: 'MH', flag: '🇲🇭', phoneCode: 692, value: 'Marshall Islands' },
        { code: 'MQ', flag: '🇲🇶', phoneCode: 596, value: 'Martinique' },
        { code: 'MR', flag: '🇲🇷', phoneCode: 222, value: 'Mauritania' },
        { code: 'MU', flag: '🇲🇺', phoneCode: 230, value: 'Mauritius' },
        { code: 'YT', flag: '🇾🇹', phoneCode: 269, value: 'Mayotte' },
        { code: 'MX', flag: '🇲🇽', phoneCode: 52, value: 'Mexico' },
        { code: 'FM', flag: '🇫🇲', phoneCode: 691, value: 'Micronesia' },
        { code: 'MD', flag: '🇲🇩', phoneCode: 373, value: 'Moldova' },
        { code: 'MC', flag: '🇲🇨', phoneCode: 377, value: 'Monaco' },
        { code: 'MN', flag: '🇲🇳', phoneCode: 976, value: 'Mongolia' },
        { code: 'MS', flag: '🇲🇸', phoneCode: 1664, value: 'Montserrat' },
        { code: 'MA', flag: '🇲🇦', phoneCode: 212, value: 'Morocco' },
        { code: 'MZ', flag: '🇲🇿', phoneCode: 258, value: 'Mozambique' },
        { code: 'NA', flag: '🇳🇦', phoneCode: 264, value: 'Namibia' },
        { code: 'NR', flag: '🇳🇷', phoneCode: 674, value: 'Nauru' },
        { code: 'NP', flag: '🇳🇵', phoneCode: 977, value: 'Nepal' },
        { code: 'NC', flag: '🇳🇨', phoneCode: 687, value: 'New Caledonia' },
        { code: 'NZ', flag: '🇳🇿', phoneCode: 64, value: 'New Zealand' },
        { code: 'NI', flag: '🇳🇮', phoneCode: 505, value: 'Nicaragua' },
        { code: 'NE', flag: '🇳🇪', phoneCode: 227, value: 'Niger' },
        { code: 'NG', flag: '🇳🇬', phoneCode: 234, value: 'Nigeria' },
        { code: 'NU', flag: '🇳🇺', phoneCode: 683, value: 'Niue' },
        { code: 'NF', flag: '🇳🇫', phoneCode: 672, value: 'Norfolk Island' },
        { code: 'MP', flag: '🇲🇵', phoneCode: 1670, value: 'Northern Mariana Islands' },
        { code: 'NO', flag: '🇳🇴', phoneCode: 47, value: 'Norway' },
        { code: 'OM', flag: '🇴🇲', phoneCode: 968, value: 'Oman' },
        { code: 'PK', flag: '🇵🇰', phoneCode: 92, value: 'Pakistan' },
        { code: 'PW', flag: '🇵🇼', phoneCode: 680, value: 'Palau' },
        { code: 'PA', flag: '🇵🇦', phoneCode: 507, value: 'Panama' },
        { code: 'PY', flag: '🇵🇾', phoneCode: 595, value: 'Paraguay' },
        { code: 'PE', flag: '🇵🇪', phoneCode: 51, value: 'Peru' },
        { code: 'PH', flag: '🇵🇭', phoneCode: 63, value: 'Philippines' },
        { code: 'PL', flag: '🇵🇱', phoneCode: 48, value: 'Poland' },
        { code: 'PT', flag: '🇵🇹', phoneCode: 351, value: 'Portugal' },
        { code: 'PR', flag: '🇵🇷', phoneCode: 1787, value: 'Puerto Rico' },
        { code: 'QA', flag: '🇶🇦', phoneCode: 974, value: 'Qatar' },
        { code: 'RO', flag: '🇷🇴', phoneCode: 40, value: 'Romania' },
        { code: 'RU', flag: '🇷🇺', phoneCode: 70, value: 'Russia' },
        { code: 'RW', flag: '🇷🇼', phoneCode: 250, value: 'Rwanda' },
        { code: 'WS', flag: '🇼🇸', phoneCode: 684, value: 'Samoa' },
        { code: 'SM', flag: '🇸🇲', phoneCode: 378, value: 'San Marino' },
        { code: 'SA', flag: '🇸🇦', phoneCode: 966, value: 'Saudi Arabia' },
        { code: 'SN', flag: '🇸🇳', phoneCode: 221, value: 'Senegal' },
        { code: 'RS', flag: '🇷🇸', phoneCode: 381, value: 'Serbia' },
        { code: 'SC', flag: '🇸🇨', phoneCode: 248, value: 'Seychelles' },
        { code: 'SL', flag: '🇸🇱', phoneCode: 232, value: 'Sierra Leone' },
        { code: 'SG', flag: '🇸🇬', phoneCode: 65, value: 'Singapore' },
        { code: 'SK', flag: '🇸🇰', phoneCode: 421, value: 'Slovakia' },
        { code: 'SI', flag: '🇸🇮', phoneCode: 386, value: 'Slovenia' },
        { code: 'SB', flag: '🇸🇧', phoneCode: 677, value: 'Solomon Islands' },
        { code: 'SO', flag: '🇸🇴', phoneCode: 252, value: 'Somalia' },
        { code: 'ZA', flag: '🇿🇦', phoneCode: 27, value: 'South Africa' },
        { code: 'SS', flag: '🇸🇸', phoneCode: 211, value: 'South Sudan' },
        { code: 'ES', flag: '🇪🇸', phoneCode: 34, value: 'Spain' },
        { code: 'LK', flag: '🇱🇰', phoneCode: 94, value: 'Sri Lanka' },
        { code: 'SD', flag: '🇸🇩', phoneCode: 249, value: 'Sudan' },
        { code: 'SR', flag: '🇸🇷', phoneCode: 597, value: 'Suriname' },
        { code: 'SZ', flag: '🇸🇿', phoneCode: 268, value: 'Swaziland' },
        { code: 'SE', flag: '🇸🇪', phoneCode: 46, value: 'Sweden' },
        { code: 'CH', flag: '🇨🇭', phoneCode: 41, value: 'Switzerland' },
        { code: 'SY', flag: '🇸🇾', phoneCode: 963, value: 'Syria' },
        { code: 'TW', flag: '🇹🇼', phoneCode: 886, value: 'Taiwan' },
        { code: 'TJ', flag: '🇹🇯', phoneCode: 992, value: 'Tajikistan' },
        { code: 'TZ', flag: '🇹🇿', phoneCode: 255, value: 'Tanzania' },
        { code: 'TH', flag: '🇹🇭', phoneCode: 66, value: 'Thailand' },
        { code: 'TG', flag: '🇹🇬', phoneCode: 228, value: 'Togo' },
        { code: 'TK', flag: '🇹🇰', phoneCode: 690, value: 'Tokelau' },
        { code: 'TO', flag: '🇹🇴', phoneCode: 676, value: 'Tonga' },
        { code: 'TN', flag: '🇹🇳', phoneCode: 216, value: 'Tunisia' },
        { code: 'TR', flag: '🇹🇷', phoneCode: 90, value: 'Turkey' },
        { code: 'TM', flag: '🇹🇲', phoneCode: 7370, value: 'Turkmenistan' },
        { code: 'TV', flag: '🇹🇻', phoneCode: 688, value: 'Tuvalu' },
        { code: 'UG', flag: '🇺🇬', phoneCode: 256, value: 'Uganda' },
        { code: 'UA', flag: '🇺🇦', phoneCode: 380, value: 'Ukraine' },
        { code: 'AE', flag: '🇦🇪', phoneCode: 971, value: 'United Arab Emirates' },
        { code: 'GB', flag: '🇬🇧', phoneCode: 44, value: 'United Kingdom' },
        { code: 'US', flag: '🇺🇸', phoneCode: 1, value: 'United States' },
        { code: 'UY', flag: '🇺🇾', phoneCode: 598, value: 'Uruguay' },
        { code: 'UZ', flag: '🇺🇿', phoneCode: 998, value: 'Uzbekistan' },
        { code: 'VU', flag: '🇻🇺', phoneCode: 678, value: 'Vanuatu' },
        { code: 'VE', flag: '🇻🇪', phoneCode: 58, value: 'Venezuela' },
        { code: 'VN', flag: '🇻🇳', phoneCode: 84, value: 'Vietnam' },
        { code: 'EH', flag: '🇪🇭', phoneCode: 212, value: 'Western Sahara' },
        { code: 'YE', flag: '🇾🇪', phoneCode: 967, value: 'Yemen' },
        { code: 'ZM', flag: '🇿🇲', phoneCode: 260, value: 'Zambia' },
        { code: 'ZW', flag: '🇿🇼', phoneCode: 26, value: 'Zimbabwe' }];

    public static currencyCodes = [
        'AED',
        'AFN',
        'ALL',
        'AMD',
        'ANG',
        'AOA',
        'ARS',
        'AUD',
        'AWG',
        'AZN',
        'BAM',
        'BBD',
        'BDT',
        'BGN',
        'BHD',
        'BIF',
        'BMD',
        'BND',
        'BOB',
        'BRL',
        'BSD',
        'BTN',
        'BWP',
        'BYR',
        'BZD',
        'CAD',
        'CDF',
        'CHF',
        'CLP',
        'CNY',
        'COP',
        'CRC',
        'CUC',
        'CUP',
        'CVE',
        'CZK',
        'DJF',
        'DKK',
        'DOP',
        'DZD',
        'EGP',
        'ERN',
        'ETB',
        'EUR',
        'FJD',
        'FKP',
        'GBP',
        'GEL',
        'GGP',
        'GHS',
        'GIP',
        'GMD',
        'GNF',
        'GTQ',
        'GYD',
        'HKD',
        'HNL',
        'HRK',
        'HTG',
        'HUF',
        'IDR',
        'ILS',
        'IMP',
        'INR',
        'IQD',
        'IRR',
        'ISK',
        'JEP',
        'JMD',
        'JOD',
        'JPY',
        'KES',
        'KGS',
        'KHR',
        'KMF',
        'KPW',
        'KRW',
        'KWD',
        'KYD',
        'KZT',
        'LAK',
        'LBP',
        'LKR',
        'LRD',
        'LSL',
        'LYD',
        'MAD',
        'MDL',
        'MGA',
        'MKD',
        'MMK',
        'MNT',
        'MOP',
        'MRO',
        'MUR',
        'MVR',
        'MWK',
        'MXN',
        'MYR',
        'MZN',
        'NAD',
        'NGN',
        'NIO',
        'NOK',
        'NPR',
        'NZD',
        'OMR',
        'PAB',
        'PEN',
        'PGK',
        'PHP',
        'PKR',
        'PLN',
        'PYG',
        'QAR',
        'RON',
        'RSD',
        'RUB',
        'RWF',
        'SAR',
        'SBD',
        'SCR',
        'SDG',
        'SEK',
        'SGD',
        'SHP',
        'SLL',
        'SOS',
        'SPL',
        'SRD',
        'STD',
        'SVC',
        'SYP',
        'SZL',
        'THB',
        'TJS',
        'TMT',
        'TND',
        'TOP',
        'TRY',
        'TTD',
        'TVD',
        'TWD',
        'TZS',
        'UAH',
        'UGX',
        'USD',
        'UYU',
        'UZS',
        'VEF',
        'VND',
        'VUV',
        'WST',
        'XAF',
        'XAG',
        'XAU',
        'XBT',
        'XCD',
        'XDR',
        'XOF',
        'XPD',
        'XPF',
        'XPT',
        'YER',
        'ZAR',
        'ZMW',
        'ZWD',
    ];
}

